import { ChevronDown } from "lucide-react";
import { type ReactNode, useState } from "react";

import { cn } from "../../lib/utils";

type CollapsibleSectionProps = {
  title: string;
  description?: string;
  defaultOpen?: boolean;
  children: ReactNode;
  badge?: ReactNode;
};

export function CollapsibleSection({
  title,
  description,
  defaultOpen = false,
  children,
  badge,
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border border-surface-700 rounded-lg overflow-hidden">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-3 hover:bg-surface-800/50 transition-colors"
      >
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-surface-300">{title}</span>
          {badge}
        </div>
        <ChevronDown
          className={cn("h-4 w-4 text-surface-400 transition-transform", isOpen && "rotate-180")}
        />
      </button>
      {isOpen && (
        <div className="px-3 pb-3 space-y-3">
          {description && <p className="text-xs text-surface-400">{description}</p>}
          {children}
        </div>
      )}
    </div>
  );
}
